export default __webpack_public_path__ + "static/media/youtube-s-icon.d83aefd3.svg";